import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addCostCenterAllocation = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    `/api/resource/Cost Center Allocation`,
    body
  );
  return data;
});
export const updateCostCenterAllocation = catchAsync(async (body, editId) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Cost Center Allocation/${editId}`,
    body
  );
  return data;
});

export const getCostCenterAllocation = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Cost Center Allocation?fields=["name","main_cost_center","company","valid_from","docstatus"]`
  );
  return data;
});
export const getCostCenterAllocationDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Cost Center Allocation/${id}`
  );
  return data;
});

export const deleteCostCenterAllocation = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Cost Center Allocation/${id}`
  );
  return data;
});

export const cancleCostCenterAllocation = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.cancel_record?record=${id}&document=Cost Center Allocation`
  );
  return data;
});
export const submitCostCenterAllocation = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    // `/api/method/technoerp.services.submit_record?record=${id}&document=Cost Center Allocation`
    `/api/method/technoerp.services.submit_doc?type=Cost Center Allocation&name=${id}`
  );
  return data;
});
